/**
 * 基础菜单 班级管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>班级管理</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="queryParams.className" placeholder="输入班级名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.idcard" placeholder="输入身份证号码"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.studentName" placeholder="输入学员姓名"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.bzr" placeholder="输入班主任"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()" v-if="xzFlag">添加</el-button>
      </el-form-item>
    </el-form>


    <!--列表-->
    <el-table size="small" :data="listData" :key="color_index" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60">
      </el-table-column>
      <el-table-column prop="className" label="班级名称" width="250" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-link type="primary" @click="openStudent(scope.row)">
            <span v-html="changeColor(scope.row.className)"></span>
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="subjectName" label="培训科目" width="350" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="fee" label="收费价格(元)" width="100">
      </el-table-column>
      <el-table-column prop="bzr" label="班主任" width="100">
      </el-table-column>
      <el-table-column prop="numberLimit" label="报名人数限制(人)" width="140">
        <template slot-scope="scope">
          <div>{{scope.row.numberLimit ? scope.row.numberLimit : '未限制' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="studentNum" label="学生数" width="70">
      </el-table-column>
      <el-table-column prop="unApproveStudentNumber" label="未审核人数" width="100">
      </el-table-column>
      <el-table-column prop="signUpEndTime" label="报名截止时间" width="160">
        <template slot-scope="scope">
          <div>{{scope.row.signUpEndTime ? scope.row.signUpEndTime : '不限制' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="top" label="是否置顶">
        <template slot-scope="scope">
          {{ scope.row.top == 1 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column prop="signUpStatus" label="是否公开报名">
        <template slot-scope="scope">
          {{ scope.row.signUpStatus == 1 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="180">
        <template slot-scope="scope">
<!--          <el-tooltip
            v-if="scope.row.kcNum == 0"
            class="item"
            effect="dark"
            content="绑定"
            placement="top"
          >
            <el-button
              size="mini"
              icon="el-icon-paperclip"
              @click="handleBind(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              @click="handleEdit(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="生成二维码"
            placement="top"
          >
            <el-button
              size="mini"
              icon="el-icon-share"
              @click="sharePopup(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>-->

          <el-tooltip
            v-if="!xzFlag"
            class="item"
            effect="dark"
            content="生成二维码"
            placement="top"
            style="margin-left: 5px;"
          >
            <el-button
              size="mini"
              icon="el-icon-paperclip"
              @click="sharePopup(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-dropdown @command="(command)=>{handleCommand(scope.row, command)}" v-if="xzFlag">
            <el-button size="mini">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1" v-if="scope.row.kcNum == 0">绑定课程</el-dropdown-item>
              <el-dropdown-item command="2" v-if="scope.row.kcNum > 0">修改课程</el-dropdown-item>
              <el-dropdown-item command="3" v-if="scope.row.kcNum > 0">清空课程</el-dropdown-item>
              <el-dropdown-item command="4">编辑班级</el-dropdown-item>
              <el-dropdown-item command="5">生成二维码</el-dropdown-item>
              <el-dropdown-item command="6">导出签到记录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-tooltip
            v-if="xzFlag"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
            style="margin-left: 5px;"
          >
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="deleteUser(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>


<!--          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="30%" top="5vh" :close-on-click-modal="false" @click="closeDialog">
      <el-form label-width="120px" :model="form" :rules="rules" ref="form" style="height: 80%; overflow-y: auto;">
        <el-form-item label="培训科目" prop="subjectId">
          <el-cascader
            size="small"
            style="width: 100%"
            v-model="form.subjectId"
            :options="treeOptions"
            emitPath="false"
            :props="{ emitPath:false }"
            clearable
          ></el-cascader>
<!--          <el-input size="small" v-model="form.subjectName" @focus="openType" placeholder="请选择培训科目"></el-input>-->
        </el-form-item>
        <el-form-item label="班级名称" prop="className">
          <el-input size="small" maxLength="255" v-model="form.className" placeholder="请输入班级名称"></el-input>
        </el-form-item>
        <el-form-item label="班主任" prop="bzrId">
          <el-select v-model="form.bzrId" placeholder="请选择班主任" filterable style="width: 100%">
            <el-option v-for="x in bzrList" :label="x.userName + ' ' + x.phone" :value="x.userSeqId" :key="x.userSeqId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收费价格(元)" prop="fee">
          <el-input size="small" v-model="form.fee" @input="formatInportData($event,'9,2','fee',form)" placeholder="请输入收费价格"></el-input>
        </el-form-item>
        <el-form-item label="报名人数限制(人)" prop="numberLimit">
          <el-input size="small" v-model="form.numberLimit" @input="formatInportData($event,'11','numberLimit',form)" placeholder="请输入班级人数"></el-input>
        </el-form-item>
        <el-form-item label="报名截止时间" prop="signUpEndTime">
          <el-date-picker type="date" placeholder="选择日期" v-model="form.signUpEndTime" style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="培训开始时间" prop="studyStartTime">
          <el-date-picker type="datetime" placeholder="选择培训开始时间" v-model="form.studyStartTime" style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="培训结束时间" prop="studyStopTime">
          <el-date-picker type="datetime" placeholder="选择培训结束时间" v-model="form.studyStopTime" style="width: 100%;"></el-date-picker>
        </el-form-item>
<!--        <el-form-item label="营销渠道">
          <el-select v-model="form.marSeqId" placeholder="请选择营销渠道">
            <el-option v-for="x in marList" :label="x.marName" :value="x.marSeqId" :key="x.marSeqId"></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="是否置顶" prop="top">
          <el-switch
            v-model="form.top"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item label="是否公开报名" prop="signUpStatus">
          <el-switch
            v-model="form.signUpStatus"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
<!--        <el-upload
          class="upload-demo"
          :action="url"
          :size="1"
          :on-progress="handlePreview"
          :on-exceed="handleExceed"
          :on-success="handleFileSuccess"
          :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
        </el-upload>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">保存</el-button>
      </div>
    </el-dialog>

    <!-- 选择 父级项目 -->
    <el-dialog :close-on-click-modal="false" title="选择科目名称" width="20vw" top="6vh" :visible.sync="openUpType" append-to-body>
      <div class="tree-con " style="margin: 0 auto">

        <div class="head-search">
          <el-input
            v-model="treeName"
            maxLength="15"
            placeholder="请输入"
            clearable
            size="small"
          >
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>

        <div class="head-tree">
          <el-tree
            :data="treeOptions"
            :props="defaultProps"
            :filter-node-method="filterNode"
            :expand-on-click-node="false"
            ref="tree"
            node-key="value"
            :default-expanded-keys="treeArr"
            @node-click="handleNodeClick2"
          >
            <div class="custom-tree-node" slot-scope="{ node, data }">
              <i
                class="custom-tree-node-icon"
                :class="node.isLeaf ? 'el-icon-aim' : 'el-icon-folder-opened'"
              ></i>
              <span
                class="s_l custom-tree-node-name "
                :title="data.label"
                :style="{ 'font-weight': node.isLeaf ? '400' : 'bold' }"
              >{{ data.label }}</span
              >
            </div>
          </el-tree>
        </div>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUpType">确 定</el-button>
        <el-button @click="cancelUpType">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 二维码弹窗 -->
    <el-dialog :close-on-click-modal="false" title="班级二维码" width="20vw" top="15vh" :visible.sync="shareShow" :before-close="handleClose" append-to-body>

      <el-form :inline="true" :model="shareForm" class="user-search" v-if="!shareUrl">
        <el-form-item label="营销渠道">
          <el-select v-model="shareForm.marSeqId" placeholder="请选择营销渠道" @change="submitShare">
            <el-option v-for="x in marList" :label="x.marName" :value="x.marSeqId" :key="x.marSeqId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-image
        v-if="shareUrl"
        style="width: 200px; height: 200px"
        :src="shareUrl"
        :preview-src-list="[shareUrl]">
      </el-image>
    </el-dialog>

    <!-- 绑定课表 -->
    <el-dialog
      title="绑定课表"
      :visible.sync="openBind"
      width="85%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @click="openBind = false;">
      <el-form label-width="120px" :model="{}" ref="form">
        <el-form-item label="课程表模版" v-if="form.kcNum == 0">
          <el-select v-model="templateId" placeholder="请选择" filterable>
            <el-option
              v-for="x in templateList"
              :label="x.mbmc"
              :value="x.id"
              :key="x.id"
              @click.native="changeTemplate(x)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择课程">
          <el-button type="primary" @click="handleCourseData()">打开课程</el-button>
        </el-form-item>

        <el-table
          size="small"
          :data="myCourseList"
          highlight-current-row
          v-loading="loading"
          border
          element-loading-text="拼命加载中"
          style="width: 99%; margin: 0 auto;"
        >
          <el-table-column label="序号" align="center" type="index" width="60"/>
          <el-table-column prop="kcmc" label="课程名称"/>
          <el-table-column prop="startTime" label="开始时间">
            <template slot-scope="scope">
              <el-date-picker type="datetime" placeholder="选择开始时间" v-model="scope.row.startTime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" :disabled="scope.row.xsNum > 0"></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column prop="endTime" label="结束时间">
            <template slot-scope="scope">
              <el-date-picker type="datetime" placeholder="选择结束时间" v-model="scope.row.endTime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" :disabled="scope.row.xsNum > 0"></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column prop="xs" label="学时" width="100">
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.xs" placeholder="请输入" @input="formatInportData($event,'4','xs',scope.row)" :disabled="scope.row.xsNum > 0"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="roomId" label="教室">
            <template slot-scope="scope">
              <el-select v-model="scope.row.roomId" placeholder="请选择" filterable :disabled="scope.row.xsNum > 0">
                <el-option
                  v-for="x in classroomList"
                  :label="x.jsmc"
                  :value="x.id"
                  :key="x.id">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="dkfs" label="签到方式" width="160">
            <template slot-scope="scope">
              <el-select v-model="scope.row.dkfs" placeholder="请选择" :disabled="scope.row.xsNum > 0">
                <el-option label="手机签到" :value="1" :key="1" />
                <el-option label="设备签到" :value="2" :key="2" />
                <el-option label="设备/手机签到" :value="3" :key="3" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="ycdksj" label="延长打卡时间（分钟）" width="160">
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.ycdksj" placeholder="请输入" @input="formatInportData($event,'4','ycdksj',scope.row)" :disabled="scope.row.xsNum > 0"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="jsxm" label="授课教师" width="120">
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.jsxm" placeholder="请输入" maxlength="10" :disabled="scope.row.xsNum > 0"></el-input>
            </template>
          </el-table-column>

          <el-table-column align="center" label="操作" width="80">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="删除"
                placement="top"
                v-if="scope.row.xsNum == 0"
              >
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  @click="delBindCourse(scope.$index, 1)"
                >
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="openBind = false;">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitCourse()">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="课程数据" :visible.sync="openCourse" width="40%" :close-on-click-modal="false" @click="openCourse = false;">
      <el-table
        ref="tableBox1"
        size="small"
        :data="courseList"
        highlight-current-row
        v-loading="loading"
        border
        element-loading-text="拼命加载中"
        style="width: 100%;"
        @selection-change="handleSelectionChange"
        :row-key="(row) => { return row.id }"
      >
        <el-table-column type="selection" width="55" align="center" :reserve-selection="true"/>
        <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60">
        </el-table-column>
        <el-table-column prop="kcmc" label="课程名称">
        </el-table-column>
        <el-table-column prop="xs" label="学时">
        </el-table-column>
      </el-table>
    </el-dialog>


  </div>
</template>

<script>
import { identificationRecognize, idCardIdentify } from '../../api/baidu'
import { identification, formatInportData, timestampToTime } from '../../utils/util'
import {
  queryByPage,
  savaClass,
  updateClass,
  deleteClass,
  queryClassDetail,
  generateQRCode, bindCourse, queryCourseByClassId, delCourseByClassId, getBzrList, getPzByShare
} from '../../api/classInfo'
import Pagination from '../../components/Pagination'
import axios from "axios";
import Template from "../../components/template";
import {selectAreaTree} from "../../api/subjectTree";
import {getCourseMbList, getMarketingChannelList, getRoomList, queryCourseMbById} from "../../api/userMG";
import {getCourseList} from "../../api/course";
export default {
  data() {
    return {
      color_index: 0,
      add_index: 0,
      url: '/api/student/upload',
      fileList: [],
      loading: false, //是显示加载
      editFormShow: false, //控制编辑页面显示与隐藏
      title: '添加',
      form: {},
      // rules表单验证
      rules: {
        subjectId: [
          { required: true, message: '请输入培训科目', trigger: 'blur' }
        ],
        className: [
          { required: true, message: '请输入班级名称', trigger: 'blur' }
        ],
        fee: [
          { required: true, message: '请输入收费价格', trigger: 'blur' }
        ],
        /*numberLimit: [
          { required: true, message: '请输入班级总人数', trigger: 'blur' }
        ],
        signUpEndTime: [
          { required: true, message: '请选择报名截止日期', trigger: 'blur' }
        ],*/
        marSeqId: [
          { required: true, message: '请选择营销渠道', trigger: 'blur' }
        ]
      },
      queryParams: {
        page: 1,
        size: 10
      },
      listData: [], //用户数据
      access_token: '', // 百度文字识别 token
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      openUpType: false,
      // 左侧树
      treeArr: [],  // 默认展示第二级树节点
      treeName: undefined,
      treeOptions: undefined,
      defaultProps: {
        children: "children",
        label: "label"
      },
      // 树状图 双击事件参数
      treeClickCnt: 0,
      treeClickTimeout: null,

      // 二维码弹窗控制
      shareShow: false,
      shareForm: {},

      marList: [],    // 营销渠道列表
      shareUrl: '',     // 二维码图片地址

      // 班级绑定课程
      templateId: '',

      toFlag: true,
      openBind: false,
      myCourseList: [],     // 所选课程
      templateList: [],     // 模版表
      classroomList: [],    // 教室
      bzrList: [],    // 班主任

      openCourse: false,
      courseList: [],       // 课程表下的课程

      xzFlag: true,
   }
  },
  watch: {
    // 根据名称筛选部门树
    treeName(val) {
      this.$refs.tree.filter(val);
    }
  },
  // 注册组件
  components: {
    Template,
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    this.initData()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    timestampToTime,
    formatInportData,
    changeColor(name) {
      const newStr = name.replace(/“([^“”]*)”/g, '<span style="color: red;">$1</span>');
      console.log('newStr', newStr);
      return newStr;
    },
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    initData() {
      this.getdata()
      this.selectAreaTree()
      this.findMarList()
      this.findClassroomList()

      var role = JSON.parse(localStorage.getItem('userdata'));
      console.log('role  ', role);
      role.roleList.forEach(x => {
        if (x.roleName == '班主任') {
          this.xzFlag = false;
        }
      })

      // 查询 班主任 下拉选
      getBzrList({page: 1, size: 9999}).then(res => {
        if (res.code == 200) {
          this.bzrList = res.data.content;
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      }).catch(err => {
        this.$message.error('加载失败，请稍后再试！')
      })
    },

    findClassroomList() {
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getRoomList({page: 1, size: 99999}).then(res => {
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.classroomList = res.data.content
        }
      })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },

    // 查询 营销渠道
    findMarList() {
      getMarketingChannelList(JSON.stringify({query: {status: 1}})).then(res => {
        if (res.code == 200) {
          this.marList = res.data.list
        }
      })
    },
    // 查询 科目树
    selectAreaTree() {
      selectAreaTree({}).then(res => {
        if (res.code == 200) {
          this.treeOptions = res.data;
          res.data.forEach(x => {
            this.treeArr.push(x.value)
          })

        }
      })
    },

    // 身份证文字识别
    idCardIdentify(idCardImg) {
      return new Promise((resolve, reject) => {
        var params = new FormData()
        params.append('image', idCardImg)//转Base64后的编码
        params.append('id_card_side', 'back')//身份证正反面参数，正：front，反：back
        params.append('access_token', this.access_token)
        axios.post(
          '/baiduOCR/rest/2.0/ocr/v1/idcard?', params,
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
        ).then((res) => {
          resolve(res.data.words_result)
        })
      })
    },
    handlePreview(event, file, fileList) {
      identification.transformBase64(file.raw).then(data => {//调用封装的base64转码方法
        console.log(`Base64---`, data)
        this.idCardIdentify(data).then(res => {//调用请求百度OCR身份证识别方法，将Base64传入
          console.log(`ocr识别----`, res)
        })
      })
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    // 成功回调
    handleFileSuccess(response, file, fileList) {
      console.log('response==', response);
      console.log('file==', file);
      console.log('fileList==', fileList);

      identification.transformBase64(file.raw).then(data => {//调用封装的base64转码方法
        console.log(`Base64---`, data)
        /*this.idCardIdentify(data).then(res => {//调用请求百度OCR身份证识别方法，将Base64传入
          console.log(`ocr识别----`, res)
        })*/
      })
    },
    identificationRecognize() {
      const data = { //这三个参数不能少
        grant_type: 'client_credentials',//固定参数
        client_id: '1gBK3e1NoRZQv89vaLmbXqfF',//你申请的AK
        client_secret: 'oqqSNa9Km2OjGO9AwbWNr29X0SfOGmr3'//你申请的SK
      }
      identificationRecognize(data).then(res => {
        console.log(`access_token---`, res)
        this.access_token = res.access_token;
      })
    },

    // 获取公司列表
    getdata() {
      // this.identificationRecognize();
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      queryByPage(this.queryParams).then(res => {
          this.loading = false
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm = res.data.pageparm
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },

    openStudent(item) {
      var {href} = this.$router.resolve({
        path: "/goods/student",
        query: {
          classId: item.id,
          type: 0
        }
      })
      window.open(href, '_blank');
    },

    // 打开父级项目选择框
    openType() {
      this.openUpType = true
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 选择父级项目 节点点击事件
    handleNodeClick2(data) {
      // 如果点击的id不相同，则重置点击次数
      if (data.value != this.form.subjectId) {
        this.treeClickCnt = 0;
      }
      this.form.subjectId = data.value
      this.form.subjectName = data.label
      this.treeClickCnt++;

      // 注册清空点击次数计时器任务
      window.clearTimeout(this.treeClickTimeout);
      this.treeClickTimeout = window.setTimeout(() => {
        this.treeClickCnt = 0;
      }, 300);

      // 连续点击多次则不做任何事情
      if (this.treeClickCnt > 2) return;
      // 点击一次时单击事件
      if (this.treeClickCnt == 1) {
        // 单击事件
        console.log('单击');
      }
      // 点击两次时双击事件
      if (this.treeClickCnt == 2) {
        // 双击事件
        console.log('双击');
        this.submitUpType()
      }

    },
    // 保存父级项目
    submitUpType() {
      this.openUpType = false;
    },
    cancelUpType() {
      this.form.subjectId = undefined
      this.form.subjectName = undefined
      this.openUpType = false;
    },

    // 搜索事件
    search() {
      this.getdata()
    },

    handleCommand(item, command) {
      if(command == 1) {
        this.handleBind(1, item);
      } else if(command == 2) {
        this.handleEditCourse(1, item)
      } else if(command == 3) {
        this.handleDelCourse(1, item)
      } else if (command == 4) {
        this.handleEdit(1, item)
      } else if (command == 5) {
        this.sharePopup(1, item);
      } else if (command == 6) {
        window.open('/api/class/exportClassSign?classId=' + item.id)
      }
    },

    // 显示 生成二维码 弹窗
    sharePopup(index, row) {
      this.form = JSON.parse(JSON.stringify(row));

      // 1：显示渠道，0：选择渠道
      getPzByShare().then(res => {
        if (res.data == 1) {
          this.shareShow = true;
        } else {
          generateQRCode({classId: this.form.id}).then(res => {
            if (res.code == 200) {
              this.shareUrl = "data:image/png; base64," + res.data;
              this.shareShow = true;
            }
          })
        }
      })
    },
    // 获取 二维码数据
    submitShare() {
      var params = {
        classId: this.form.id,
        marSeqId: this.shareForm.marSeqId
      }
      generateQRCode(params).then(res => {
        if (res.code == 200) {
          this.shareUrl = "data:image/png; base64," + res.data;
        }
      })
    },
    handleClose(done) {
      this.shareForm.marSeqId = '';
      this.shareUrl = '';
      done();
    },

    // 修改课程
    handleEditCourse(index, row) {
      this.form = JSON.parse(JSON.stringify(row));

      queryCourseByClassId(row.id).then(res => {
        if (res.code == 200) {
          this.myCourseList = res.data;

          getCourseList({page:1, size: 99999, subjectId: row.subjectId}).then(res => {
            if (res.code == 200) {
              if (res.data.content.length > 0) {
                var list = [];
                res.data.content.forEach(x => {
                  list.push({
                    kcmc: x.kcmc,
                    courseId: x.id,
                    roomId: '',
                    startTime: '',
                    endTime: '',
                    xs: x.xs,
                    dkfs: '',
                    ycdksj: '',
                    xsNum: 0
                  })
                })

                this.courseList = list;
                this.openBind = true;
              }
            }
          }).catch(err => {
            this.$message.error(err.response.data.msg)
          })
        }
      })
    },
    // 清空课程
    handleDelCourse(index, row) {
      this.$confirm('确定要删除绑定的课程吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delCourseByClassId(row.id).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    // 绑定 按钮操作
    handleBind(index, row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.templateId = '';
      this.myCourseList = [];
      this.courseList = [];

      getCourseMbList({page: 1, size: 99999, subjectId: row.subjectId}).then(res => {
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.templateList = res.data.content;
          this.openBind = true;
        }
      })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },

    // 获取课程表模版的课程
    changeTemplate(row) {
      // 切换模版，清空已选择的课程
      this.myCourseList = [];
      queryCourseMbById(row.id).then(res => {
        if (res.code == 200) {

          if (res.data.courseMbItemList.length > 0) {
            var list = [];
            res.data.courseMbItemList.forEach(x => {
              list.push({
                kcmc: x.kcmc,
                courseId: x.courseId,
                roomId: '',
                startTime: '',
                endTime: '',
                xs: x.xs,
                dkfs: '',
                ycdksj: '',
                xsNum: 0
              })
            })

            this.courseList = list;
          }
        }
      })
    },

    // 打开课程
    handleCourseData() {

      if (this.courseList.length > 0) {
        this.openCourse = true;

        if (this.myCourseList.length > 0) {
          var list = [];

          this.courseList.forEach(x => {
            this.myCourseList.forEach(y => {
              if (x.courseId == y.courseId) {
                list.push(x);
              }
            })
          });

          this.$nextTick(() => {
            list.forEach(x => {
              this.$refs.tableBox1.toggleRowSelection(x, true);
            })
          })

        } else {
          this.openCourse = true;
          this.$refs.tableBox1.clearSelection();
        }

      } else {
        this.$message.error('请先选择课程表模版');
      }
    },

    handleSelectionChange(selection) {
      console.log('selection  ', selection);

      var ids = [];
      if (this.myCourseList.length > 0) {
        ids = this.myCourseList.map(item => item.courseId);
        var list = [];
        selection.forEach(x => {
          if (ids.indexOf(x.courseId) == -1) {
            list.push(x)
          }
        })

        this.myCourseList = [...this.myCourseList, ...list];
      } else {
        this.myCourseList = JSON.parse(JSON.stringify(selection));
      }
    },

    // 删除绑定过的课程
    delBindCourse(index) {
      this.myCourseList.splice(index, 1)
      this.$refs.tableBox1.clearSelection();
    },

    submitCourse() {
      if (this.form.kcNum == 0) {
        if (!this.templateId) {
          this.$message.error('课程表模版不可为空');
          return;
        }
      }

      if (this.myCourseList.length == 0) {
        this.$message.error('请选择需要绑定的课程。');
      } else {

        for (let i = 0; i < this.myCourseList.length; i++) {
          var x = this.myCourseList[i];

          if (!x.startTime) {
            this.$message.error('开始时间不可为空');
            return;
          }
          if (!x.endTime) {
            this.$message.error('结束时间不可为空');
            return;
          }
          if (!x.xs) {
            this.$message.error('学时不可为空');
            return;
          }
          if (!x.roomId) {
            this.$message.error('教室不可为空');
            return;
          }
          if (!x.dkfs) {
            this.$message.error('签到方式不可为空');
            return;
          }
          if (!x.ycdksj) {
            this.$message.error('延长打卡时间不可为空');
            return;
          }
        }

        var params = {
          classId: this.form.id,
          lessonList: this.myCourseList
        }

        bindCourse(JSON.stringify(params)).then(res => {
          if (res.code == 200) {
            this.getdata();
            this.form = {}
            this.$message({
              type: 'success',
              message: '保存成功！'
            });
            this.openBind = false;
          } else {
            this.$message.error(res.msg);
          }
        })
      }

    },

    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormShow = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        queryClassDetail(row).then(res => {
          if (res.code == 200) {
            this.form = res.data;
          }
        })
      } else {
        this.title = '添加'
        this.form = {}
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.form.id) {

            // 修改
            if (this.form.signUpEndTime) {
              this.form.signUpEndTime = timestampToTime(this.form.signUpEndTime)
            }
            if (this.form.studyStartTime) {
              this.form.studyStartTime = timestampToTime(this.form.studyStartTime)
            }
            if (this.form.studyStopTime) {
              this.form.studyStopTime = timestampToTime(this.form.studyStopTime)
            }
            updateClass(this.form).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '修改成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('修改失败，请稍后再试！')
            })

          } else {

            // 新增
            if (this.form.signUpEndTime) {
              this.form.signUpEndTime = timestampToTime(this.form.signUpEndTime)
            }
            if (this.form.studyStartTime) {
              this.form.studyStartTime = timestampToTime(this.form.studyStartTime)
            }
            if (this.form.studyStopTime) {
              this.form.studyStopTime = timestampToTime(this.form.studyStopTime)
            }
            savaClass(this.form).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除该条数据吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteClass(row).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('删除失败，请稍后再试！')
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.form = {}
      this.editFormShow = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

.tree-con {
  width: 250px;
  height: 95%;
  vertical-align: text-top;
  margin-top: 20px;
  display: inline-block;
  border: #544E4F 2px solid;
  border-radius: 8px;
}

</style>





// WEBPACK FOOTER //
// src/views/goods/classInfo.vue